const transcriptRows = [
  ["YOU · 09:18", "b92 strong", "b64"],
  ["CLIENT · 09:42", "b84", "b55"],
  ["CLIENT · 11:42", "b94 strong2", "b80 strong2", "b58 strong2"],
  ["YOU · 12:03", "b74 strong", "b43"],
  ["CLIENT · 12:19", "b90", "b57"],
];

function ReviewArtifact() {
  return (
    <div className="seo-hero-artifact__scene scene-review">
      <div className="review-stack">
        <div className="paper review-back" />
        <div className="paperclip" />
        <div className="paper transcript-paper">
          <div className="paper-head"><b>CALL TRANSCRIPT</b><span>18 SEP · 28:14</span></div>
          {transcriptRows.map(([speaker, ...bars], index) => (
            <div key={speaker} className={`tr ${index === 2 ? "marked" : ""} ${index === transcriptRows.length - 1 ? "no-border" : ""}`}>
              <small>{speaker}</small>
              <div>{bars.map((bar, barIndex) => <i key={`${speaker}-${barIndex}`} className={`bar ${bar}`} />)}</div>
              {index === 2 && (
                <svg viewBox="0 0 420 84" preserveAspectRatio="none" focusable="false">
                  <path d="M18 44C37 7 351 3 398 31C429 50 390 76 224 77C76 78-4 66 18 44Z" />
                  <path className="echo" d="M25 38C80 10 334 10 395 34" />
                </svg>
              )}
            </div>
          ))}
        </div>
        <div className="real-pen"><span className="cap" /><span className="body" /><span className="tip" /></div>
      </div>
    </div>
  );
}

function AnalysisArtifact() {
  return (
    <div className="seo-hero-artifact__scene scene-analysis">
      <div className="analysis-slip analysis-slip--evidence">
        <span className="analysis-slip__kicker">CUSTOMER</span>
        <blockquote>“Budget isn't the issue.”</blockquote>
        <div className="analysis-slip__footer"><span>EVIDENCE</span><i /></div>
      </div>

      <div className="analysis-slip analysis-slip--signal">
        <span className="analysis-slip__kicker">WHAT CHANGED</span>
        <strong>Internal buy-in is the blocker.</strong>
        <div className="analysis-marker" aria-hidden="true"><span /></div>
      </div>

      <div className="analysis-slip analysis-slip--next">
        <span className="analysis-slip__kicker">NEXT MOVE</span>
        <strong>Bring Operations into the next call.</strong>
        <div className="analysis-check" aria-hidden="true"><span>✓</span><i /></div>
      </div>
    </div>
  );
}

function ComparisonArtifact() {
  return (
    <div className="seo-hero-artifact__scene scene-ci">
      <div className="summary-sheet paper">
        <div className="mini-clip" />
        <div className="summary-kicker">CALL SUMMARY</div>
        <i className="bar b88 strong" /><i className="bar b72" /><i className="bar b82" /><i className="bar b56" />
        <div className="short-rule" />
        <i className="bar b70" /><i className="bar b42" />
      </div>
      <div className="dossier">
        <div className="folder-back" />
        <div className="folder-tab t1">CALLS</div><div className="folder-tab t2">NOTES</div><div className="folder-tab t3">NEXT</div>
        <div className="folder-sheet fs3" /><div className="folder-sheet fs2" />
        <div className="folder-sheet fs1">
          <div className="dossier-head"><span className="avatar-dot" /><div><b>Customer file</b><small>Relationship history</small></div></div>
          {[0, 1, 2, 3].map((item) => <div className="history-line" key={item}><span /><i /></div>)}
        </div>
      </div>
    </div>
  );
}

function PrepareArtifact() {
  return (
    <div className="seo-hero-artifact__scene scene-prepare">
      <div className="planner">
        <div className="planner-spine" />
        <div className="planner-left">
          <div className="date-label">PREVIOUS CALL</div>
          <i className="note-line n92" /><i className="note-line n74" /><i className="note-line n84" />
          <div className="margin-note">?</div>
          <i className="note-line n62" /><i className="note-line n76" />
        </div>
        <div className="planner-right">
          <div className="date-label">NEXT CALL</div>
          {[0, 1, 2, 3].map((item) => <div className="prep-item" key={item}><span /><i /></div>)}
        </div>
      </div>
      <div className="phone">
        <div className="phone-speaker" />
        <div className="phone-screen"><span className="phone-avatar" /><b>15:30</b><i /><i /></div>
      </div>
      <div className="glasses"><span /><span /><i /></div>
    </div>
  );
}

function CrmNoteArtifact() {
  return (
    <div className="seo-hero-artifact__scene scene-crm">
      <div className="card-box">
        <div className="box-back" />
        <div className="index-card card-3"><span className="card-tab">FOLLOW-UP</span></div>
        <div className="index-card card-2"><span className="card-tab">OWNER</span></div>
        <div className="index-card card-1">
          <span className="card-tab active">ACCOUNT</span>
          <div className="card-title"><span className="avatar-dot" /><div><b>Customer record</b><small>Updated after call</small></div></div>
          {["Blocker", "Stakeholder", "Commitment", "Next step"].map((label) => <div className="card-field" key={label}><b>{label}</b><i /></div>)}
        </div>
        <div className="box-front" />
      </div>
      <div className="binder-clip"><i /></div>
    </div>
  );
}

function DebriefArtifact() {
  return (
    <div className="seo-hero-artifact__scene scene-debrief">
      <div className="clipboard">
        <div className="clip-metal"><span /></div>
        <div className="worksheet">
          <div className="ws-head"><b>CALL DEBRIEF</b><span>28 MIN</span></div>
          <div className="ws-section"><strong>What changed?</strong><i /><i className="short" /></div>
          <div className="ws-section"><strong>Evidence</strong><i /><i /></div>
          <div className="ws-section checks"><strong>Next move</strong><div><span>✓</span><i /></div><div><span /><i /></div></div>
          <div className="ws-footer"><span /><span /><span /></div>
        </div>
      </div>
      <div className="wood-pencil"><span className="eraser" /><span className="shaft" /><span className="lead-tip" /></div>
    </div>
  );
}

function FollowUpArtifact() {
  return (
    <div className="seo-hero-artifact__scene scene-followup">
      <div className="laptop">
        <div className="laptop-screen">
          <div className="camera-dot" />
          <div className="mail-window">
            <div className="mail-top"><span /><span /><span /></div>
            <div className="mail-row"><b>To</b><i className="mail-pill" /></div>
            <div className="mail-row"><b>Subject</b><i className="subject-line" /></div>
            <div className="mail-body"><i className="m90" /><i className="m72" /><i className="m83" /><span className="mail-gap" /><i className="m76" /><i className="m58" /><span className="mail-gap" /><i className="m62" /></div>
            <span className="send-button">Send</span>
          </div>
        </div>
        <div className="laptop-base"><div className="keys" /><div className="trackpad" /></div>
      </div>
      <div className="earbud-case"><span /></div>
    </div>
  );
}

function CoachingArtifact() {
  return (
    <div className="seo-hero-artifact__scene scene-coaching">
      <div className="notebook">
        <div className="nb-left">
          <div className="nb-date">CALL NOTES</div>
          <i className="ink-line l88" /><i className="ink-line l72" />
          <div className="crossed"><i className="ink-line l82" /><span /></div>
          <i className="ink-line l61" /><i className="ink-line l76" />
        </div>
        <div className="nb-rings" />
        <div className="nb-right">
          <div className="nb-date">BETTER NEXT TIME</div>
          <div className="hand-note">Ask before defending</div>
          <i className="ink-line l86 purple" /><i className="ink-line l67 purple" />
          <div className="arrow-note">↳</div>
          <i className="ink-line l74" /><i className="ink-line l57" />
        </div>
      </div>
      <div className="highlighter"><span className="hl-cap" /><span className="hl-body" /><span className="hl-tip" /></div>
    </div>
  );
}

function RenewalArtifact() {
  return (
    <div className="seo-hero-artifact__scene scene-renewal">
      <div className="calendar">
        <div className="cal-rings"><span /><span /><span /><span /></div>
        <div className="cal-head">OCTOBER</div>
        <div className="cal-grid">
          {Array.from({ length: 28 }, (_, index) => index === 17 ? <i className="renew-date" key={index}><b>18</b></i> : <i key={index} />)}
        </div>
        <div className="renew-label">RENEWAL CALL</div>
      </div>
      <div className="client-folder">
        <div className="cf-tab">CUSTOMER</div>
        <div className="cf-paper"><i /><i /><i /><i /></div>
      </div>
      <div className="sticky"><b>Before call</b><i /><i /><i /></div>
    </div>
  );
}

function GongArtifact() {
  return (
    <div className="seo-hero-artifact__scene scene-gong">
      <div className="report-stack">
        <div className="report r3" /><div className="report r2" />
        <div className="report r1">
          <div className="report-head">CALL REPORT</div><i /><i /><i /><div className="score-row"><span /><span /><span /></div>
        </div>
      </div>
      <div className="binder">
        <div className="binder-cover left-cover" /><div className="binder-cover right-cover" />
        <div className="binder-page left-page">
          <div className="binder-title">CUSTOMER</div>
          <i className="bline w82" /><i className="bline w64" />
          <div className="tiny-timeline"><span /><i /><span /><i /><span /></div>
        </div>
        <div className="binder-rings"><span /><span /><span /></div>
        <div className="binder-page right-page">
          <div className="artifact-tabs"><span>CALLS</span><span>NOTES</span><span>RENEWAL</span></div>
          {[0, 1, 2, 3].map((item) => <div className="rel-entry" key={item}><b /><i /></div>)}
        </div>
      </div>
    </div>
  );
}

const artifacts = {
  review: ReviewArtifact,
  analysis: AnalysisArtifact,
  comparison: ComparisonArtifact,
  prepare: PrepareArtifact,
  crmNote: CrmNoteArtifact,
  debrief: DebriefArtifact,
  followUp: FollowUpArtifact,
  coaching: CoachingArtifact,
  relationship: RenewalArtifact,
  gong: GongArtifact,
};

export default function SeoHeroSpecimen({ variant }) {
  const Artifact = artifacts[variant];
  if (!Artifact) return null;

  return (
    <aside className={`seo-hero-specimen seo-hero-specimen--${variant}`} aria-hidden="true">
      <div className="seo-hero-artifact">
        <Artifact />
      </div>
    </aside>
  );
}
